module.exports = __webpack_public_path__ + "static/media/forecast.c1a81635.svg";